/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `title` - Title
 * * `subtitle` - Subtitle
 * * `description` - Description
 * * `organization` - Organization
 * * `contact` - Contact
 * * `website` - Website
 * * `email` - Email
 * * `phone_number` - Phone number
 * * `location` - Address
 * * `date_time_information` - Hours
 * * `collections` - Categories
 * * `other` - Other
 */
export type FieldsEnum = typeof FieldsEnum[keyof typeof FieldsEnum];


export const FieldsEnum = {
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  organization: 'organization',
  contact: 'contact',
  website: 'website',
  email: 'email',
  phone_number: 'phone_number',
  location: 'location',
  date_time_information: 'date_time_information',
  collections: 'collections',
  other: 'other',
} as const;
